
export const typeData = [
    { name: "Planning d'éclairage", id: "light" },
    { name: "Planning de température", id: "temperature" },
    { name: "Planning de valeurs libres", id: "free" },
    { name: "Planning pour équipement spécifique", id: "equipment" },
]

export const daysofweekData = [
    { name: "Lundi", id: 1 },
    { name: "Mardi", id: 2 },
    { name: "Mercredi", id: 3 },
    { name: "Jeudi", id: 4 },
    { name: "Vendredi", id: 5 },
    { name: "Samedi", id: 6 },
    { name: "Dimanche", id: 0 },
]

export const lightStateData = [
    { name: "Eteint", id: 0, color: "#9798A0", textColor: "#FFFFFF" },
    { name: "Allumé", id: 1, color: "#D6D22F", textColor: "#000000" },
]

export const destinationData = [
    { name: "AVOB Box", id: "avobbox" },
    { name: "Serveur LoRaWAN", id: "avoblorawanserver" },
    { name: "Serveur Wiotys", id: "wiotyslorawanserver" },
]